import { baseServiceInvoiceSchema } from "@redotech/redo-model/billing/service-invoice";
import * as z from "zod/v4";

export const getFinalizedServiceInvoices = {
  name: "getFinalizedServiceInvoices" as const,
  input: z.null(),
  output: z.array(baseServiceInvoiceSchema),
};
